
	import Promise, { reject, resolve } from 'bluebird';
	import _ from 'lodash';
	import Data from 'app-core/Data';
	import config from 'app-core/config';

	let loadedPresets = [];
	let presetsPromise = null;

	config.eventsBus.$on('clear-cache', () => {
		presetsPromise = null;
		loadedPresets = [];
	});

	export default {
		getPresets(type) {			
			if (!presetsPromise) {
				if (__DEBUG__)
					console.debug('Get presets');
				presetsPromise = new Promise((resolve, reject) => {
					Promise.all([
						Data.getExternalApi('Preset/GetPresets', 'type=0&IsPublic=true'), 
						Data.getExternalApi('Preset/GetPresets', 'type=0&IsPublic=false')
					]).then(results => {						
						loadedPresets = [...results[0].Results, ...results[1].Results].map(f => {
							try {
								var json = JSON.parse(f.Json);
								return { data: json && json.data, type: json && json.type, name: f.Name, id: f.Oid, allowDelete: !f.IsPublic };
							} catch {
								//
							}
							return null;
						}).filter(f => f);

						if (__DEBUG__)
							console.debug('Presets loaded', { loadedPresets });

						resolve(loadedPresets);
					}).catch((ex) => reject(ex));
					return null;
				}).catch(() => presetsPromise = null);
			}
			return presetsPromise.then(r => loadedPresets.filter(f => f.type === type));
		},
		savePreset(preset) {
			var payload = {
				data: preset.data,
				type: preset.type
			};
			const existing = loadedPresets.find(f => f.allowDelete && f.name === preset.name && f.type === preset.type);
			if (existing) {
				_.assign(existing.data, preset.data);
			}
			return Data.postExternalApi('Preset/CreateUpdatePreset', {
				Oid: existing?.id,
				Name: preset.name,
				PresetType: 0,
				IsPublic: false,
				Json: JSON.stringify(payload)
			}).then((r) => {
				if (!existing && r && r.Success !== false) {
					loadedPresets.push({ ...preset, id: r.Data.Oid });
				}
			});
		},
		removePreset(preset) {
			return new Promise((res, rej) => {
				config.getVueApp().$confirmMessage({
					title: config.getVueApp().$tCaption('Confirm action', '@actions'),
					text: config.getVueApp().$tCaption('Do you want to delete preset?'),
					handler() {
						_.remove(loadedPresets, f => f.id === preset.id);
						Data.getExternalApi('Preset/DeletePreset', `presetId=${preset.id}`);
						res();
					},
					cancel: () => rej()
				});
			})
		}
	};
